import * as React from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { editPublicacion } from '../../../../actions/publicacionesActions';


class DescripcionAmpliada extends React.Component {

    handleEditorChange = (content) => {
        let publicacion = { ...this.props.publicacion };
        publicacion["descripcionAmpliada"] = content;
        this.props.editPublicacion(publicacion);
    }

    render() {
        return (
            <div>
                <ReactQuill
                    className=""
                    theme="snow"
                    modules={DescripcionAmpliada.modules}
                    value={this.props.publicacion.descripcionAmpliada}
                    onChange={this.handleEditorChange}
                />
            </div>
        );
    }
}

DescripcionAmpliada.modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],          // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 },],                // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],       // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],           // outdent/indent
        [{ 'direction': 'rtl' }],                           // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }],    // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],            // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean']
    ]
}


const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    tipoUsuario: state.general.tipoUsuario
})

export default connect(mapStateToProps, { editPublicacion })(DescripcionAmpliada);